// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"2f60b5e6","879":"ab3494dd"}[chunkId] + ".chunk.js";
};